export default class{

    constructor(options){

        this.el = options.el;

        this.ui = options.ui;

        this.model = options.model;

        this.modalEl = null;

        this.modalHelper = options.modalHelper;

        this.events = options.events || {};

        this.events.click = options.click;

        this.getTemplate = options.getTemplate;

        Object
            .keys(options)
            .filter(x => typeof options[x]==='function')
            .forEach(x => {
                this[x] = options[x].bind(this);
            });
    }

    render(data){

        this.__data = data

        let el = $(this.el);

        if (this.getTemplate) {
          this.template = this.getTemplate(data)
        }

        if(typeof this.template === 'function'){
            let template = $(this.template(data));
            el.html(template);
        }else{
            el.html(this.template);
        }

        this.$el = el;

        this.registerUIs();
        this.registerEvents();
        this.onRender();
    }

    registerUIs(){

        if(!this.ui){
            return;
        }

        Object
            .keys(this.ui)
            .forEach(x => this.ui[x] = $(this.ui[x], this.$el));
    }

    registerEvents(){

        Object
            .keys(this.events)
            .filter(x=> x!=="click")
            .map(x=> {

                let [event, selector, extra] = x.split('@');
                let parent = this.$el
                let _dom = $(selector, parent)

                if (selector === "") {
                  // in this case you are binding "change @@input"
                  // you want to bind a DOM element outside your view.
                  _dom = $(extra)
                }
                
                _dom.on(event.trim(), (e)=> {

                    let callback = this.events[x];

                    if(typeof(callback) === 'string'){
                        this[callback](e);
                    }else{
                        this.events[x](e);
                    }
                });
            });
    }

    onRender(){}

    /* *********************************** *
    *               Modal
    *  *********************************** */

    showModal({bgColor=null, icon=null, title=null, message=null, ok=false, confirm=false, cancel=false}){

        if(!this.modalHelper){
            throw Error('Invalid or not specified modal Engine.');
        }

        var data = {};

        if(message !== null && typeof message === 'object'){
            data = message;
        }else{
            if(message){
                data.message = message;
            }
        }

        data.modalSettings = {
            icon: icon,
            ok: ok,
            confirm: confirm,
            cancel: cancel,
            title: title
        };

        this.modalEl = $(this.modalHelper.el);
        let compiled = $(this.modalHelper.template(data));
        this.modalEl.html(compiled);

        $(this.modalHelper.body, this.modalEl).show();
        $(this.modalHelper.preload, this.modalEl).hide();

        if(ok){
            $('[data-modal-ok]', this.modalEl).on('click', (e)=>{this.onOk(e)});
        }
        if(confirm){
            $('[data-modal-confirm]', this.modalEl).on('click', (e)=>{this.onConfirm(e)});
        }
        if(cancel){
            $('[data-modal-cancel]', this.modalEl).on('click', (e)=>{this.onCancel(e)});
        }

        this.modalEl.removeClass().addClass('error-message modal ' + bgColor);

        this.modalEl.css('display', 'block');
    }

    hideModal(){
        this.modalEl.css('display', 'none');
    }

    modalStartPreload(){
        if(!this.modalEl){
            return 0;
        }

        $(this.modalHelper.body, this.modalEl).hide();
        $(this.modalHelper.preload, this.modalEl).show();
    }

    onConfirm(){
        this.hideModal();
    }

    onCancel(){
        this.hideModal();
    }

    onOk(){
        this.hideModal();
    }

    /* *********************************** *
     *             Data Model
     *  *********************************** */

    onData(data){}

    fetchFromModel(){
        if(this.model){
            return this.model
                .fetch()
                .done((data)=> this.onData(data));
        }
    }
}